import React, { ReactNode, createContext, useContext, useReducer } from 'react';
import { TCurrencyData } from '@common/types';
import { DEFAULT_CURRENCY } from '@utils/constants';

interface CurrencyContextProviderProps {
  children?: ReactNode;
  currencyData: TCurrencyData;
  taxRate: number;
  isInPriceTaxInclusiveCountry?: boolean;
}

type State = {
  currencyData: TCurrencyData;
  taxRate: number;
  isInPriceTaxInclusiveCountry?: boolean;
};

interface CurrencyContextType extends State {
  dispatch: (arg: any) => void;
}

const CurrencyContext = createContext<CurrencyContextType | null>(null);

function mainReducer(state: State, action: any) {
  switch (action.type) {
    default:
      return state;
  }
}

export function CurrencyContextProvider(props: CurrencyContextProviderProps) {
  const currencyCode = props.currencyData.currencyCode ?? DEFAULT_CURRENCY;
  const conversionRate = props.currencyData.conversionRate ?? 1;
  const [state, dispatch] = useReducer(mainReducer, {
    currencyData: { currencyCode, conversionRate },
    taxRate: props.taxRate ?? 0,
    isInPriceTaxInclusiveCountry: props.isInPriceTaxInclusiveCountry,
  });
  return (
    <CurrencyContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {props.children}
    </CurrencyContext.Provider>
  );
}

export function useCurrencyContext() {
  const appContext = useContext(CurrencyContext);
  if (!appContext) {
    throw new Error(
      'useCurrencyContext must be used within the CurrencyContext.Provider',
    );
  }
  return appContext;
}
